<template>
  <div class="d-flex flex-column g-4">
    <div class="d-flex align-items-center justify-content-between">
      <h3 class="mb-0">{{ translate("automation.conditions") }}</h3>
      <ModalCloseButtonView @click="$emit('close')"/>
    </div>
    <div v-for="(disjunction, dindex) in conditions" :key="dindex" class="d-flex flex-column g-2">
      <h3 class="text-foreground mb-0 text-uppercase text-center">{{ dindex === 0 ? translate("automation.if") : translate("automation.or") }}</h3>
      <div class="list-group">
        <div v-for="(conjunction, cindex) in disjunction" :key="cindex" class="list-group-item">
          <div class="d-flex align-items-center justify-content-between g-2">
            <ConditionView class="w-100" :community-id="communityId" :conditions="allConditions" :data-types="dataTypes" :trigger="trigger" :errors="errors && errors[dindex] && errors[dindex][cindex] ? errors[dindex][cindex] : undefined" :value="conjunction" @update:value="updateConjunction(dindex, cindex, $event)"/>
            <ButtonView type="soft" color="danger" size="small" @click="removeConjunction(dindex, cindex)">
              <i class="fas fa-trash"></i>
            </ButtonView>
          </div>
        </div>
        <button class="list-group-item list-group-item-action text-primary" @click="addConjunction(dindex)">
          <span class="d-flex align-items-center justify-content-center g-2">
            <i class="fas fa-plus"></i>
            <span>{{ translate('automation.and') }}</span>
          </span>
        </button>
        <button v-if="dindex === conditions.length - 1" class="list-group-item list-group-item-action text-primary" @click="addDisjunction">
          <span class="d-flex align-items-center justify-content-center g-2">
            <i class="fas fa-plus"></i>
            <span>{{ translate('automation.or') }}</span>
          </span>
        </button>
      </div>
    </div>
    <ButtonView v-if="!conditions || conditions.length === 0" type="normal" color="primary" class="w-100" @click="addDisjunction">
      <div class="d-flex align-items-center justify-content-center g-2">
        <i class="fas fa-plus"></i>
        <span>{{ translate('automation.condition') }}</span>
      </div>
    </ButtonView>
  </div>
</template>

<script>
import ConditionView from "@/systems/modules/automation/form/conditions/ConditionView.vue";
import {ButtonView, ModalCloseButtonView} from "@/niftybit";

export default {
  name: "AutomationRuleConditionsForm",
  components: {ConditionView, ButtonView, ModalCloseButtonView},
  props: {
    communityId: String,
    trigger: Object,
    dataTypes: Array,
    conditions: Array,
    allConditions: Array,
    errors: [Object, Array]
  },
  emits: ["update:conditions", "close"],
  methods: {
    addConjunction(disjunctionIndex) {
      this.updateConditions(items => items[disjunctionIndex] !== undefined ? items[disjunctionIndex].push({}) : items[disjunctionIndex] = []);
    },
    addDisjunction() {
      this.updateConditions(items => items.push([{}]));
    },
    updateConjunction(disjunctionIndex, conjunctionIndex, value) {
      this.updateConditions(item => item[disjunctionIndex][conjunctionIndex] = value);
    },
    updateConditions(callback) {
      let item = JSON.parse(JSON.stringify(this.conditions ?? []));
      callback(item);
      this.$emit("update:conditions", item);
    },
    removeConjunction(disjunctionIndex, conjunctionIndex) {
      this.updateConditions(item => {
        item[disjunctionIndex].splice(conjunctionIndex, 1);
        if (item[disjunctionIndex].length === 0) item.splice(disjunctionIndex, 1);
      });
    },
    removeDisjunction(disjunctionIndex) {
      this.updateConditions(item => item.splice(disjunctionIndex, 1));
    }
  }
}
</script>

<style scoped>

</style>